import { cn } from "@/lib/utils"
import {
  Activity,
  Bot,
  Calendar,
  CreditCard,
  Flag,
  MessageSquare,
  Plug,
  Target,
  User,
  UserCog,
} from "lucide-react"
import { Link, useLocation, useParams } from "react-router-dom"

interface TabItem {
  id: string
  label: string
  icon: React.ComponentType<{ className?: string }>
  path: string
}

/**
 * Componente de navegação por abas para detalhes do usuário
 */
export function UserTabNavigation() {
  const location = useLocation()
  const { id } = useParams<{ id: string }>()

  const tabs: TabItem[] = [
    {
      id: "overview",
      label: "Visão Geral",
      icon: User,
      path: `/admin/users/${id}/overview`,
    },
    {
      id: "agents",
      label: "Agentes",
      icon: Bot,
      path: `/admin/users/${id}/agents`,
    },
    {
      id: "leads",
      label: "Leads",
      icon: Target,
      path: `/admin/users/${id}/leads`,
    },
    {
      id: "appointments",
      label: "Agendamentos",
      icon: Calendar,
      path: `/admin/users/${id}/appointments`,
    },
    {
      id: "providers",
      label: "Profissionais & Agenda",
      icon: UserCog,
      path: `/admin/users/${id}/providers`,
    },
    {
      id: "communication",
      label: "Comunicação",
      icon: MessageSquare,
      path: `/admin/users/${id}/communication`,
    },
    {
      id: "activities",
      label: "Atividades",
      icon: Activity,
      path: `/admin/users/${id}/activities`,
    },
    {
      id: "integrations",
      label: "Integrações",
      icon: Plug,
      path: `/admin/users/${id}/integrations`,
    },
    {
      id: "subscriptions",
      label: "Assinaturas",
      icon: CreditCard,
      path: `/admin/users/${id}/subscriptions`,
    },
    {
      id: "feature-flags",
      label: "Feature Flags",
      icon: Flag,
      path: `/admin/users/${id}/feature-flags`,
    },
  ]

  const currentTab = tabs.find(tab => location.pathname.includes(tab.id)) || tabs[0]

  return (
    <div className="border-b">
      <nav className="flex space-x-8 px-6" aria-label="Tabs">
        {tabs.map(tab => {
          const isActive = currentTab.id === tab.id
          const Icon = tab.icon

          return (
            <Link
              key={tab.id}
              to={tab.path}
              className={cn(
                "flex items-center gap-2 border-b-2 px-1 py-4 text-sm font-medium transition-colors",
                isActive
                  ? "border-primary text-primary"
                  : "text-muted-foreground hover:text-foreground hover:border-muted-foreground border-transparent"
              )}
            >
              <Icon className="h-4 w-4" />
              {tab.label}
            </Link>
          )
        })}
      </nav>
    </div>
  )
}
